/* ===================================================================
   PasswordInput -- a text input with an inline Show / Hide reveal toggle.
   Reproduces the LOCKED auth-screen pattern (Steve 2026-07-08) so a
   fat-finger never creates an unloggable account / mismatched password.

   Drop-in for any password <input className="inp" .../>: it renders the
   same field (inherits whatever .inp treatment its context provides -- auth
   card, settings, onboarding) plus a right-aligned "Show"/"Hide" text button.
   The toggle only flips the local reveal state; it never changes value flow,
   name, autoComplete, or submit behavior.
   =================================================================== */
import { useState } from 'react';
import type { InputHTMLAttributes } from 'react';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function PasswordInput({ className = 'inp', style, ...props }: PasswordInputProps) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <input
        {...props}
        type={show ? 'text' : 'password'}
        className={className}
        style={{ width: '100%', paddingRight: 60, ...style }}
      />
      <button
        type="button"
        className="link"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Hide password' : 'Show password'}
        /* Inline color/weight mirror the .link class so the toggle looks right
           even on pages that do not load auth.css (Settings / Integrations). */
        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 13, fontWeight: 600, color: 'var(--accent-soft)', background: 'none', border: 0, cursor: 'pointer' }}
      >
        {show ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}

export default PasswordInput;
